import React from 'react';
import styled, { css } from 'styled-components';
import { SortDirection as SortDirection_ } from '@tanstack/react-table';
import { ReactComponent as TableSortSvg_ } from './TableSort.svg';
import { IGutterAsMarginProps } from '../../fundamentals/spaces/space';
import { useGutterAsMarginCss } from '../../fundamentals/spaces/space';
import { PX_TO_REM } from '../../fundamentals/sizes/sizes';
import { useTestId } from '../../hooks/useTestId/useTestId';

export const SORT_DIRECTION = {
  UP: 'up',
  DOWN: 'down',
  UNSORTED: 'unsorted'
} as const;

export type SortDirection = (typeof SORT_DIRECTION)[keyof typeof SORT_DIRECTION];

export interface ITableSortProps extends IGutterAsMarginProps {
  /** Use to set direction if not using @tanstack/react-table */
  direction?: SortDirection;
  /** If using @tanstack/react-table set this to result of header.column.getIsSorted() */
  isSorted?: false | SortDirection_;
}

const getSortDirection = (direction: undefined | SortDirection, isSorted: undefined | false | SortDirection_) => {
  if (direction) return direction;
  if (!isSorted) return SORT_DIRECTION.UNSORTED;
  return isSorted === 'asc' ? SORT_DIRECTION.UP : SORT_DIRECTION.DOWN;
};

const TableSortSvg = styled(TableSortSvg_)``;

export const TableSort = styled(({ isSorted, direction, ...rest }: ITableSortProps) => {
  const { generateTestId } = useTestId(rest, 'TableSort');

  return <TableSortSvg {...rest} {...generateTestId()} />;
})`
  ${useGutterAsMarginCss({ left: 8 })}
  margin-bottom: -${PX_TO_REM[2]};
  & #up,
  #down {
    fill: ${({ theme }) => theme.tableColours.sort.off.background};
    stroke: ${({ theme }) => theme.tableColours.sort.off.background};
  }
  ${({ direction, isSorted, theme }) => {
    if (getSortDirection(direction, isSorted) === SORT_DIRECTION.UP)
      return css`
        & #up {
          fill: ${theme.tableColours.sort.on.background};
          stroke: ${theme.tableColours.sort.on.background};
        }
      `;
    if (getSortDirection(direction, isSorted) === SORT_DIRECTION.DOWN)
      return css`
        & #down {
          fill: ${theme.tableColours.sort.on.background};
          stroke: ${theme.tableColours.sort.on.background};
        }
      `;
  }}
`;
